import { JellyfinItem } from "../api/jellyfin";

// Jellyfin may return video/watchlist playlists from the generic Playlist query.
// Keep the Music section audio-only. Remux reports video watchlists as
// MediaType "Unknown", so permissively accepting untyped/unknown playlists
// leaks those lists into every Music sidebar.
export function musicPlaylistsOnly(items: JellyfinItem[]) {
  return items.filter(
    (item) => item.MediaType?.toLowerCase() === "audio",
  );
}
